import { Button } from '@packages/shared/src/ui/Button/Button';
import { defineMessage, useIntl } from 'react-intl';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { dispatchButtonTracking } from '@packages/shared/src/ui/Button/dispatchButtonTracking';
import type { ButtonHTMLAttributes } from 'react';
import { buttonStylingTailwind } from './Actions.styles';

export interface BasketEditActionProps {
  mode: 'basket';
  /** Overrides the default click-tracking category (used e.g. for check-and-order). */
  trackingCategory?: string;
  /** Click-tracking detail, alongside an overridden trackingCategory. */
  trackingDetail?: string;
}

export interface WishlistEditActionProps {
  mode: 'wishlist';
  trackingCategory?: string;
  trackingDetail?: string;
}

export type EditActionProps = BasketEditActionProps | WishlistEditActionProps;

const message = defineMessage({
  id: 'EditAction.ButtonText',
  defaultMessage: 'Ändern',
  description: 'this will be displayed on the button',
});

export const EditAction = ({
  onClick,
  trackingCategory,
  trackingDetail,
  ...props
}: EditActionProps & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>) => {
  const { formatMessage } = useIntl();
  const dispatchGlycerin = useTracking();

  const onClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    dispatchButtonTracking({
      eventDispatcher: dispatchGlycerin,
      type: 'button',
      clickTrackingProps: {
        category: trackingCategory ?? 'Artikel Ändern',
        detail: trackingDetail,
        label: 'Produktkonfiguration',
      },
    });
    onClick?.(event);
  };

  return (
    <Button
      className={buttonStylingTailwind}
      onClick={onClickHandler}
      data-testid="edit-action"
      variant="icon-flat"
      size="base"
      {...props}
    >
      <div className="icon-emp-edit size-4 md:size-3" />
      {formatMessage(message)}
    </Button>
  );
};
